export const HES_STATUS_PAY = 2;
export const HES_STATUS_PENDING = 1;
export const HES_STATUS_PARTIAL = 3;
export const HES_STATUS_PAY_TEXT = 'bost_Close';
export const HES_STATUS_PENDING_TEXT = 'bost_Open';
export const HES_STATUS_LIST = [
  {
    text: "Todos",
    value: null,
  },
  {
    text: "Cerrada",
    value: HES_STATUS_PAY,
  },
  {
    text: "Abierta",
    value: HES_STATUS_PENDING,
  },
  {
    text: "Parcial",
    value: HES_STATUS_PARTIAL,
  },
];
export const OC_CREATED_IN_PLATFORM = 1

//IVA CONSTANTS
export const DECIMAL_IVA_APLICABLE = 0.19;

export const calculateTotalAmountHes = (item, currentServiceWithHes) => {
  return (
    Number(item.quantity) * currentServiceWithHes.price_with_tax
  ).toFixed(currentServiceWithHes.currency == "CLP" ? 0 : 2);
}

export const calculateNetAmountHes = (item, currentServiceWithHes) => {
  if (
    currentServiceWithHes.applied_tax &&
    currentServiceWithHes.tax_code === "IVA"
  ) {
    let totalAmountHes = calculateTotalAmountHes(item, currentServiceWithHes);
    let netAmount = totalAmountHes / (1 + DECIMAL_IVA_APLICABLE);
    //Tomar solo dos decimales
    netAmount = Number(
      netAmount.toFixed(
        currentServiceWithHes.currency == "CLP" ? 0 : 2
      )
    );
    return netAmount;
  } else {
    return calculateTotalAmountHes(item, currentServiceWithHes);
  }
}
  
export const getAllHes = (service) => {
  return  [
    ...service.created_hes,
    ...service.inventory_entries
      .filter((item) => {
        return !service.created_hes.some(
          (hes) =>
            hes.inventory_entry.sap_code ==
            item.inventory_entry.sap_code
        );
      })
      .map((item) => {
        return {
          ...item,
          created_by: "-",
          created_at: item.inventory_entry.created_at,
          created_in_sap: true,
        };
      }),
    ]
};
